import webPart from './webPart'
 


export default{
    webPart 
}